var path = '/pages/guestlists/directives/checkin/checkin-directive.tpl.html';
var html = "<pre>{{vm.model | json}}</pre>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/guestlists/directives/checkin/checkin-directive.tpl.html
// module id = 2256
// module chunks = 1